// extracted by mini-css-extract-plugin
module.exports = {"result":"ClientSearch_result__1vj5G","name":"ClientSearch_name__1uaGr","search":"ClientSearch_search__1ejAE"};